export const REQUEST_SENT = 'api/REQUEST_SENT';

export const REQUEST_SUCCEEDED = 'api/REQUEST_SUCCEEDED';

export const REQUEST_FAILED = 'api/REQUEST_FAILED';

export const CLEAR_API_MESSAGE = 'api/CLEAR_API_MESSAGE';

export const HTTP_ERROR = 'Un problème technique est survenu';
